import React from 'react';
import { isHTML } from '../../../../utils/helpers';

interface Props {
  text: string;
  className?: string;
}

const DocumentField: React.FC<Props> = ({ text, className = '' }) => {
  if (isHTML(text)) {
    return <div className={className} dangerouslySetInnerHTML={{ __html: text }} />;
  }

  return <p className={className}>{text}</p>;
};

export default DocumentField;
